import { getFlattenedCountryList } from '@/constants/pickerRegions/regions'
import type { SupportedAlpha2CountryCode } from './getSupportedAlpha2CountryCodes'
import { getSupportedLanguages } from './getSupportedLanguages'

export const getLanguagesByAlpha2CountryCode = (
  alpha2CountryCode: SupportedAlpha2CountryCode,
) => {
  const allCountries = getFlattenedCountryList()
  const allSupportedLanguages = getSupportedLanguages()

  type SupportedLanguage = (typeof allSupportedLanguages)[number]

  const alpha2CountryCodeUpperCase =
    alpha2CountryCode.toUpperCase() as SupportedAlpha2CountryCode

  const supportedLanguagesForLocale =
    allCountries[alpha2CountryCodeUpperCase] || []

  return supportedLanguagesForLocale as readonly SupportedLanguage[]
}
